import * as React from "react";

const RestaurantGroup = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.24257 7.49715L6.42661 6.25023L3.48952 3.16155C2.83683 3.8489 2.83683 4.96365 3.48952 5.6554L5.24257 7.49715ZM8.07925 6.69965C8.71939 7.01248 9.61893 6.79218 10.2842 6.09161C11.0833 5.25004 11.2381 4.04277 10.6231 3.39508C10.0122 2.75179 8.86583 2.9104 8.06252 3.75197C7.39728 4.45254 7.18808 5.39985 7.48514 6.07398L3.40165 10.3743L3.99158 10.9956L6.87429 7.9686L9.75281 11L10.3427 10.3787L7.46422 7.34734L8.07925 6.69965Z"
      fill="currentColor"
    />
    <path
      d="M15.2426 7.49715L16.4266 6.25023L13.4895 3.16155C12.8368 3.8489 12.8368 4.96365 13.4895 5.6554L15.2426 7.49715ZM18.0793 6.69965C18.7194 7.01248 19.6189 6.79218 20.2842 6.09161C21.0833 5.25004 21.2381 4.04277 20.6231 3.39508C20.0122 2.75179 18.8658 2.9104 18.0625 3.75197C17.3973 4.45254 17.1881 5.39985 17.4851 6.07398L13.4017 10.3743L13.9916 10.9956L16.8743 7.9686L19.7528 11L20.3427 10.3787L17.4642 7.34734L18.0793 6.69965Z"
      fill="currentColor"
    />
    <path
      d="M10.2426 17.4972L11.4266 16.2502L8.48952 13.1616C7.83683 13.8489 7.83683 14.9636 8.48952 15.6554L10.2426 17.4972ZM13.0793 16.6996C13.7194 17.0125 14.6189 16.7922 15.2842 16.0916C16.0833 15.25 16.2381 14.0428 15.6231 13.3951C15.0122 12.7518 13.8658 12.9104 13.0625 13.752C12.3973 14.4525 12.1881 15.3998 12.4851 16.074L8.40165 20.3743L8.99158 20.9956L11.8743 17.9686L14.7528 21L15.3427 20.3787L12.4642 17.3473L13.0793 16.6996Z"
      fill="currentColor"
    />
  </svg>
);

export default RestaurantGroup;
